import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../../actions/userActions";
import "./AuthScreen.css";

export default function ForgotPasswordScreen() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");

  const userForgotPassword = useSelector((state) => state.userForgotPassword);
  const { loading, error, success } = userForgotPassword;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(forgotPassword(email));
  };

  return (
    <section className="auth-shell">
      <div className="auth-card">
        <div className="auth-grid">
          <div className="auth-panel auth-panel--form">
            <h1 className="auth-title">Forgot password</h1>

            <p className="auth-copy auth-copy--lead">
              Enter the email you used to create your account and we’ll send you
              a reset link.
            </p>

            {error && <div className="auth-alert">{error}</div>}
            {success && (
              <div className="auth-success">
                If an account exists for that email, a reset link has been sent.
              </div>
            )}

            <form className="auth-form" onSubmit={submitHandler}>
              <div className="auth-field">
                <label htmlFor="email">Your email*</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>

              <button
                type="submit"
                className="auth-btn auth-btn--primary"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send reset link"}
              </button>

              <Link to="/login" className="auth-inline-link">
                Back to sign in
              </Link>
            </form>
          </div>

          <div className="auth-panel auth-panel--info">
            <h2 className="auth-side-title">Need help?</h2>
            <p className="auth-copy auth-copy--spacious">
              If you don’t see the email within a few minutes, check your spam
              or promotions folder. Make sure you entered the email address you
              used at checkout.
            </p>

            <Link to="/register" className="auth-btn auth-btn--secondary">
              Create an account
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
